<template>
  <FsTooltip
    ref="accountRef"
    :teleport="false"
    placement="bottom-end"
    trigger="hover"
    :offsetY="11"
    :popperContentStyle="{
      width: '288px',
      maxWidth: '288px',
      padding: '16px',
      borderRadius: '8px',
    }"
  >
    <a class="account_icon" href="javascript:;">
      <span class="iconfont iconfont_nav icon-account"></span>
    </a>
    <template #content>
      <h3 class="welcome">Hi,{{ userInfo?.customers_firstname }}</h3>
      <div class="account_menu">
        <a v-for="(item, index) in accountMenu" :key="index" href="javascript:;" @click.stop="click(item)">{{
          item.title
        }}</a>
      </div>
    </template>
  </FsTooltip>
</template>
<script setup lang="ts">
import { FsTooltip, FsButton, FsSelect, FsDialog, FsMessage } from 'fs-design'
import { onMounted, computed, ref, reactive } from 'vue'
import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'
import { handleFsLink } from '@/utils'
import { Cookie } from '@/utils'
interface AccountMenu {
  title: string
  path: string
}

const userStore = useUserStore()

const accountMenu = reactive<AccountMenu[]>([
  {
    title: 'My Account',
    path: '/my-account',
  },
  {
    title: 'Orders',

    path: '/order-history',
  },
  {
    title: 'Quotes',
    path: '/quote_history.html',
  },
  {
    title: 'Sign Out',
    path: '/quote_history.html',
  },
])

const {isLogin,userInfo} = storeToRefs(userStore)

const click = (item: AccountMenu) => {
  if (item.title === 'Sign Out') {
    Cookie.delete("token_new");
	setTimeout(()=>{
		location.href = handleFsLink('/')
	},0)
	
  } else {
    location.href = handleFsLink(item.path)
  }
}
</script>
<style lang="scss" scoped>
.welcome {
  text-align: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e5e5;
  font-weight: 600;
  @include font14;
  color: #19191a;
}
.account_menu {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  a {
    width: 100%;
    height: 100%;
    padding: 7px;
    border-radius: 4px;
    display: flex;
    cursor: pointer;
    @include font13;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #707070;
    transition: all 0.3s;
	cursor: pointer;
    &:hover {
      background: #f2f2f2;
      color: #19191a;
    }
  }
}
.account_icon {
  color: #19191a;
  &:hover {
    text-decoration: none;
  }
}
.iconfont_nav {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 8px;
  font-size: 24px;
  border-radius: 4px;
  transform: all 0.3s;
  &:hover {
    background-color: #f2f2f2;
  }
}
</style>
